import { z } from 'zod';

export const establishmentBlockSchema = z.object({
  block_reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type EstablishmentBlockValidationSchema = z.infer<typeof establishmentBlockSchema>;

export const establishmentUnblockSchema = z.object({
  unblock_reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type EstablishmentUnblockValidationSchema = z.infer<typeof establishmentUnblockSchema>;
